import { render, staticRenderFns } from "./page-fb.vue?vue&type=template&id=7af91bdb&"
import script from "./page-fb.vue?vue&type=script&lang=js&"
export * from "./page-fb.vue?vue&type=script&lang=js&"
import style0 from "./page-fb.vue?vue&type=style&index=0&id=7af91bdb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports